/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetGateDeliveryNotePdfs$Params {
  token: Token64LengthType;
}

export function externalGetGateDeliveryNotePdfs(http: HttpClient, rootUrl: string, params: ExternalGetGateDeliveryNotePdfs$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, externalGetGateDeliveryNotePdfs.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

externalGetGateDeliveryNotePdfs.PATH = '/external/gate/delivery-note-pdfs';
